module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/is-iterable.js
// module id = 873
// module chunks = 1 2 3 4 5 6 7 11 17 19 20 21 22 23 25 26 27 28 29 30 32 50 53